// extracted by mini-css-extract-plugin
var _1 = "WithdrawProcessStyles-module__loaderWrapper___j_8v_";
var _2 = "WithdrawProcessStyles-module__steps___Z37ta";
export { _1 as "loaderWrapper", _2 as "steps" }
